module.exports = __webpack_public_path__ + "media/images/sp/brands/eight/store_nagoya-e665345ea60483c8c9827267d2fd36e4.jpg";